import { trainingCourseAssistantManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const trainingCourseAssistantManagementRouteMetadata: IRouteMetadataObj<
  typeof trainingCourseAssistantManagementRoutesObj
> = {
  list: {
    title: "trainingCourseAssistantManagement.index.title",
    description: "trainingCourseAssistantManagement.index.description",
    lazy: () => import("@/pages/trainingCourseAssistantManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "UserAddLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "trainingCourseAssistantManagement.create.title",
    description: "trainingCourseAssistantManagement.create.description",
    lazy: () => import("@/pages/trainingCourseAssistantManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "UserFollowLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "trainingCourseAssistantManagement.edit.title",
    description: "trainingCourseAssistantManagement.edit.description",
    lazy: () => import("@/pages/trainingCourseAssistantManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
};

export const trainingCourseAssistantManagementRoutes = createRoute<
  typeof trainingCourseAssistantManagementRoutesObj
>(
  trainingCourseAssistantManagementRoutesObj,
  trainingCourseAssistantManagementRouteMetadata,
);
